import React from "react";
import { useDesigner } from "./useDesigner";
import { DesignerMessages, getTypeName } from "./types";
import { AllContent, Content, Section, SubReport, TOC } from "../core/pdf/types";
import { useChannel } from "../core/hooks/useChannel";
import { pasteHtmlAtCaret } from "../core/utils/html";
import { useConditional } from "../core/hooks/useConditional";
import { FieldEditor } from "./FieldEditor";
import { ElementState } from "./useElementContext";
import { Modal } from "../core/ui/Modal";
import { EditableRegion } from "../core/form/EditableRegion";
import { TagEditor } from "../layout/TagEditor";
import { useDataContext } from "../core/hooks/useData";

export function Toolbar(props: {

}) {

	const designer = useDesigner();
	
	const editField = useConditional((msg: any) => {
		return (
			<FieldEditor
				fieldOptions={msg.fieldOptions}
				field={msg.field}
				onClose={editField.close}
				onSave={() => {
					// sync the updated DOM attribute back to paragraph.html
					if (msg.elementContext?.def?.id != null) {
						designer.broadcastToContent(msg.elementContext.def.id, {
							type: DesignerMessages.CHANGED,
						});
					}
				}}
			/>
		)
	})

	useChannel(designer.channel, React.useCallback((msg) => {
		if (msg.type === DesignerMessages.EDIT_FIELD) {
			editField.show(msg);

		}
	}, [designer.focus, editField]));

	const confirmDelete = useConditional(() => {
		return (
			<Modal
				title="Confirm Delete"
				size="width-25vw"
				saveTitle="Continue"
				onSave={designer.delete}
				onCancel={confirmDelete.close}
			>
				Are you sure you want to delete this report?
			</Modal>
		)
	});

	const data = useDataContext({
		initialValue: designer.def,
	});

	return (
		<div
			className="toolbar flex horiz gap-1 padding-2"
		>

			<div>
				<EditableRegion
					className="text-inverse font-large padding-left-5"
					intialHtml={designer.title}
					onChange={(e) => {
						designer.title = e.target.value;
					}}
				/>
			</div>

			<div className="fill flex vert">
				<TagEditor dbObj={designer.def} />
			</div>

			<button
				className="flat"
				onClick={() => {
					designer.cancel();
				}}
			>Cancel</button>

			<button
				className="error"
				onClick={() => {
					confirmDelete.show({});
				}}
			>Delete</button>

			<button
				className="primary"
				onClick={() => {
					designer.preview();
				}}
			>Preview</button>

			<button
				className="primary"
				onClick={() => {
					designer.save(false);
				}}
			>Save</button>

			<button
				className="primary"
				onClick={() => {
					designer.save(true);
				}}
			>Save &amp; Close</button>

			{editField.render()}
			{confirmDelete.render()}

		</div>
	)
}
